const Header = () => {
    return (
        <div>
                <nav className="navbar navbar-expand-lg navbar-light fixed-top shadow-sm bg-black" id="mainNav">
        <div className="container">
            <a className="navbar-brand fw-bold text-white" href="#page-top">Rapidfast</a>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive"
                aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                <i className="bi-list text-white"></i>
            </button>
            <div className="collapse navbar-collapse" id="navbarResponsive">
                <ul className="navbar-nav ms-auto me-4 my-3 my-lg-0">
                    <li className="nav-item "><a className="nav-link me-lg-3 text-white" href="#features">Servicios</a></li>
                    <li className="nav-item "><a className="nav-link me-lg-3 text-white" href="#download">Download</a></li>
                    <li className="nav-item "><a href="#contact" className="nav-link me-lg-3 text-white"><span
                                className="d-flex align-items-center">
                                <i className="bi-chat-text-fill me-2"></i>
                                <span className="small">Contactenos</span>
                            </span>
                        </a></li>
                </ul>
            </div>
        </div>
    </nav>
        </div>
    )
}

export default Header
